var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tabbar-router-container", staticStyle: { height: "100%" } },
    [
      _c("router-view", { staticClass: "tabbar-router-content" }),
      _vm._v(" "),
      _c(
        "van-tabbar",
        {
          attrs: { "active-color": "#EE2E50", value: _vm.cTabIndexNew },
          on: { change: _vm.tabChanged }
        },
        [
          _c(
            "van-tabbar-item",
            {
              scopedSlots: _vm._u([
                {
                  key: "icon",
                  fn: function(props) {
                    return _c("div", { staticClass: "icon" }, [
                      _c("img", {
                        attrs: {
                          src: props.active
                            ? _vm.icon[0].active
                            : _vm.icon[0].normal
                        }
                      })
                    ])
                  }
                }
              ])
            },
            [_c("span", [_vm._v("首页")])]
          ),
          _vm._v(" "),
          _c(
            "van-tabbar-item",
            {
              scopedSlots: _vm._u([
                {
                  key: "icon",
                  fn: function(props) {
                    return _c("div", { staticClass: "icon" }, [
                      _c("img", {
                        attrs: {
                          src: props.active
                            ? _vm.icon[1].active
                            : _vm.icon[1].normal
                        }
                      })
                    ])
                  }
                }
              ])
            },
            [_c("span", [_vm._v("全部商品")])]
          ),
          _vm._v(" "),
          _c(
            "van-tabbar-item",
            {
              scopedSlots: _vm._u([
                {
                  key: "icon",
                  fn: function(props) {
                    return _c("div", { staticClass: "icon" }, [
                      _c("img", {
                        attrs: {
                          src: props.active
                            ? _vm.icon[2].active
                            : _vm.icon[2].normal
                        }
                      })
                    ])
                  }
                }
              ])
            },
            [_c("span", [_vm._v("网点")])]
          ),
          _vm._v(" "),
          _c(
            "van-tabbar-item",
            {
              staticClass: "cartStyle",
              scopedSlots: _vm._u([
                {
                  key: "icon",
                  fn: function(props) {
                    return _c("div", { staticClass: "icon" }, [
                      _c("img", {
                        attrs: {
                          src: props.active
                            ? _vm.icon[3].active
                            : _vm.icon[3].normal
                        }
                      })
                    ])
                  }
                }
              ])
            },
            [_c("span", [_vm._v("购物车")])]
          ),
          _vm._v(" "),
          _c(
            "van-tabbar-item",
            {
              scopedSlots: _vm._u([
                {
                  key: "icon",
                  fn: function(props) {
                    return _c("div", { staticClass: "icon" }, [
                      _c("img", {
                        attrs: {
                          src: props.active
                            ? _vm.icon[4].active
                            : _vm.icon[4].normal
                        }
                      })
                    ])
                  }
                }
              ])
            },
            [_c("span", [_vm._v("我的")])]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }